import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import SimpleBar from 'simplebar-react';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { getFolderStructure } from '../../slices/thunks';
import { constants } from '../../config';
import { filesize } from 'filesize';
import { LoadingOverlay } from '@mantine/core';

function parseFileSize(size) {
	const units = {
		B: 1,
		KB: 1000,
		MB: 1000 * 1000,
		GB: 1000 * 1000 * 1000,
		TB: 1000 * 1000 * 1000 * 1000,
	};

	const regex = /^(\d+\.?\d*)\s*([BKMGT]B)$/i;
	const matches = size.match(regex);

	if (!matches) {
		throw new Error('Formato de tamaño no válido');
	}

	const value = parseFloat(matches[1]);
	const unit = matches[2].toUpperCase();

	if (!units.hasOwnProperty(unit)) {
		throw new Error('Unidad de tamaño no válida');
	}

	return value * units[unit];
}

export const FolderTreeSection = props => {
	// {}JSON.parse(sessionStorage.getItem('authUser')));
	const {
		current_folder,
		setCurrent_Folder,
		filterActive,
		setFilterActive,
		establishmentId
	} = props;

	const dispatch = useDispatch();

	const selectFileManagerState = state => state.FileManager;
	const selectFileManagerProperties = createSelector(
		selectFileManagerState,
		state => ({
			folders: state.folders,
			folder_structure: state.folder_structure,
			folderStructureIsLoading: state.folderStructureIsLoading
		})
	);

	const {
		folders,
		folder_structure,
		folderStructureIsLoading
	} = useSelector(
		selectFileManagerProperties
	);

	const currentStorage = useMemo(
		() =>
			folders ? folders.reduce((acc, folder) => acc + folder.size, 0) : 0,
		[folders]
	);

	const maxStorage = useMemo(
		() => parseFileSize(constants.REACT_APP_FILE_MANAGER_STORAGE_SIZE),
		[constants.REACT_APP_FILE_MANAGER_STORAGE_SIZE]
	);

	useEffect(() => {
		dispatch(getFolderStructure({establishment_id: establishmentId}));
	}, [establishmentId]);

	const fileCategory = (e, ele) => {
		setFilterActive(ele);
		document.getElementById('collapseDivRoot').classList.remove('show');
	};

	function findFolderPath(tree, targetId, currentPath = []) {
		for (const folder of tree) {
			const newPath = [...currentPath, folder._id];

			if (folder._id === targetId) {
				return newPath;
			}

			if (folder.children && folder.children.length > 0) {
				const foundPath = findFolderPath(
					folder.children,
					targetId,
					newPath
				);
				if (foundPath) {
					return foundPath;
				}
			}
		}

		return null;
	}

	const currentPath = useMemo(
		() => findFolderPath(folder_structure, current_folder._id),
		[folder_structure, current_folder._id]
	);

	const renderFolders = folders => {
		return folders && folders.length
			? folders.map(folder => {
					return (
						<li
							style={{
								marginLeft: `20px`,
							}}
							key={folder._id}
						>
							<a
								role='button'
								aria-expanded={
									currentPath && currentPath.includes(folder._id)
								}
							>
								<i
									onClick={e => {
										if (folder.children.length > 0) {
											let element = document.getElementById(
												`collapseDiv${folder._id}`
											);
											if (element.classList.contains('show')) {
												element.classList.remove('show');
												e.target.classList.remove(
													'ri-folder-2-fill'
												);
												e.target.classList.add('ri-folder-2-line');
											} else {
												element.classList.add('show');
												e.target.classList.remove(
													'ri-folder-2-line'
												);
												e.target.classList.add('ri-folder-2-fill');
											}
										}
									}}
									className={`ri-folder-2${
										currentPath && currentPath.includes(folder._id)
											? '-fill'
											: '-line'
									} align-bottom me-2`}
								></i>{' '}
								<span
									onClick={e => setCurrent_Folder(folder)}
									className='file-list-link'
								>
									{folder.name}
								</span>
							</a>
							{folder.children.length > 0 && (
								<div
									className={`collapse ${
										currentPath && currentPath.includes(folder._id)
											? 'show'
											: ''
									}`}
									id={`collapseDiv${folder._id}`}
								>
									<ul className='list-unstyled'>
										{renderFolders(folder.children)}
									</ul>
								</div>
							)}
						</li>
					);
			  })
			: null;
	};

	function getProgressBarClass(currentStorage, maxStorage) {
		const percentage = (currentStorage / maxStorage) * 100;

		if (percentage > 80) {
			return 'bg-danger';
		} else if (percentage >= 70) {
			return 'bg-warning';
		} else {
			return 'bg-success';
		}
	}

	return (
		<div className='file-manager-sidebar'>
			<div className='p-3 d-flex flex-column h-100'>
				<div className='mb-3'>
					<h5 className='mb-0 fw-bold'>Unidad Compartida</h5>
				</div>
				<div className='search-box'>
					<input
						type='text'
						className='form-control bg-light border-light'
						placeholder='Search here...'
					/>
					<i className='ri-search-2-line search-icon'></i>
				</div>
				<SimpleBar className='mt-3 mx-n4 px-4 file-menu-sidebar-scroll'>
					<ul className='list-unstyled file-manager-menu'>
						<li>
							<a
								data-bs-toggle='collapse'
								role='button'
								aria-expanded='true'
								aria-controls='collapseExample'
							>
								<i
									onClick={e => {
										let element =
											document.getElementById('collapseDivRoot');
										if (element.classList.contains('show')) {
											element.classList.remove('show');
											e.target.classList.remove('ri-folder-2-fill');
											e.target.classList.add('ri-folder-2-line');
										} else {
											element.classList.add('show');
											e.target.classList.remove('ri-folder-2-line');
											e.target.classList.add('ri-folder-2-fill');
										}
									}}
									className={`ri-folder-2-fill align-bottom me-2`}
								></i>{' '}
								<span
									onClick={() => {
										fileCategory(
											'Unidad Compartida',
											'Unidad Compartida'
										);
										document
											.getElementById('collapseDivRoot')
											.classList.add('show');
										setCurrent_Folder({
											_id: '/',
											name: 'Unidad Compartida',
										});
									}}
									className='file-list-link'
								>
									Unidad Compartida
								</span>
							</a>
							<div
								style={{
									position: 'relative',
								}}
							>
								<LoadingOverlay visible={folderStructureIsLoading} opacity={0.5} />
								<div className='collapse show' id='collapseDivRoot'>
									<ul className='list-unstyled'>
										{renderFolders(folder_structure)}
									</ul>
								</div>
							</div>
						</li>
						<li>
							<a
								href='#!'
								className={filterActive === 'Recents' ? 'active' : ''}
								onClick={() => fileCategory('Media', 'Recents')}
							>
								<i className='ri-history-line align-bottom me-2'></i>{' '}
								<span className='file-list-link'>Recientes</span>
							</a>
						</li>
						<li>
							<a
								href='#!'
								className={filterActive === 'Important' ? 'active' : ''}
								onClick={() => fileCategory('Documents', 'Important')}
							>
								<i className='ri-star-line align-bottom me-2'></i>{' '}
								<span className='file-list-link'>Importantes</span>
							</a>
						</li>
						<li>
							<a
								href='#!'
								className={filterActive === 'Deleted' ? 'active' : ''}
								onClick={() => fileCategory('Deleted', 'Deleted')}
							>
								<i className='ri-delete-bin-line align-bottom me-2'></i>{' '}
								<span className='file-list-link'>Eliminados</span>
							</a>
						</li>
					</ul>
				</SimpleBar>

				<div className='mt-auto'>
					<h6 className='fs-12 text-muted text-uppercase mb-3'>
						Estado del Almacenamiento
					</h6>
					<div className='d-flex align-items-center'>
						<div className='flex-shrink-0'>
							<i className={`${Icons.database} fs-13`}></i>
						</div>
						<div className='flex-grow-1 ms-3 overflow-hidden'>
							<div className='progress mb-2 progress-md'>
								<div
									className={`progress-bar ${getProgressBarClass(
										currentStorage,
										maxStorage
									)}`}
									role='progressbar'
									style={{
										width: `${(currentStorage / maxStorage) * 100}%`,
									}}
									aria-valuenow={currentStorage}
									aria-valuemin={0}
									aria-valuemax={maxStorage}
								></div>
							</div>
							<span className='text-muted fs-12 d-block text-truncate'>
								<b>{filesize(currentStorage)}</b> usado de{' '}
								<b>{filesize(maxStorage)}</b>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
